import React from 'react'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { Icon } from '@iconify/react'
import { BhyveNavNotificationsTrigger } from './BhyveNavNotificationsTrigger'
import { bhyveNavTokens as T } from './bhyveNavTokens'

export type BhyveMobilePrimaryBarProps = {
  title: string
  onOpenMenu: () => void
  menuOpen: boolean
}

/**
 * Bottom chrome when the persistent rail is collapsed: menu + context title + notifications (matches mobile nav design).
 */
export const BhyveMobilePrimaryBar: React.FC<BhyveMobilePrimaryBarProps> = ({ title, onOpenMenu, menuOpen }) => {
  return (
    <Box
      data-bhyve-mobile-primary-bar
      sx={{
        gridRow: 4,
        zIndex: theme => theme.zIndex.appBar,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 1,
        px: 2,
        pt: 1,
        pb: 'max(12px, env(safe-area-inset-bottom, 0px))',
        borderTop: `1px solid ${T.sidebarBorder}`,
        bgcolor: T.sidebarBg,
        minHeight: 56,
        boxSizing: 'border-box'
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          mr: 0.5
        }}
      >
        <IconButton
          color='inherit'
          aria-label='Open navigation menu'
          aria-expanded={menuOpen ? 'true' : 'false'}
          aria-haspopup='dialog'
          size='medium'
          onClick={onOpenMenu}
          sx={{ color: T.sidebarText, ml: 0, p: 1 }}
        >
          <Icon icon='tabler:menu-2' width={26} height={26} />
        </IconButton>
      </Box>
      <Typography
        variant='body2'
        component='div'
        noWrap
        sx={{
          flex: 1,
          minWidth: 0,
          textAlign: 'center',
          fontWeight: 600,
          fontSize: 15,
          color: T.sidebarText,
          lineHeight: 1.25
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          minWidth: 44
        }}
      >
        <BhyveNavNotificationsTrigger />
      </Box>
    </Box>
  )
}
